const readMockApiBaseUrl = (): string => (process.env as Record<string, string | undefined>)["VITE_MOCK_API_URL"] || "";

export default readMockApiBaseUrl;
